
























































import {Component, Vue, Watch} from "vue-property-decorator";
import {NotificationStore} from "@/modules/notifications/store";
import {NotificationParams} from "@/modules/notifications/params";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {NotificationTargetType} from '@/enums/type';
import NotificationEmployeeTableAction
    from "@/modules/notifications/notificationemployee/List/components/TableAction.vue";
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";
import EmployeeSelector from "@/shared/components/EmployeeSelector/index.vue";
import CustomerSelector from "@/shared/components/CustomerSelector/index.vue";
import TooltipLabel from "@/shared/components/TooltipLabel/TooltipLabel.vue";

@Component({
    name: "NotificationEmployeeList",
    components: {TooltipLabel, CustomerSelector, EmployeeSelector, NotificationEmployeeTableAction},
})
export default class extends mixins(CommonMixin) {
    params = new NotificationParams()
    columns = [
        {
            title: "STT",
            dataIndex: "stt",
            key: "stt",
            width: 60
        },
        {
            title: "Ngày tạo",
            dataIndex: "createdDate",
            key: "createdDate",
            width: 180,
            ellipsis: true
        },
        {
            title: "Đại diện gửi",
            dataIndex: "createdByRowGuid",
            key: "createdBy",
            scopedSlots: {customRender: "createdBy"},
            width: 250,
            ellipsis: true
        },
        {
            title: "Shipper",
            dataIndex: "accountRowGuid",
            key: "accountRowGuid",
            scopedSlots: {customRender: "shipper"},
            width: 250,
            ellipsis: true
        },
        {
            title: "Nội dung thông báo",
            dataIndex: "content",
            key: "content",
            ellipsis: true,
            scopedSlots: {customRender: "content"}
        },
        {
            title: "Thao tác",
            dataIndex: "id",
            key: "id",
            scopedSlots: {customRender: 'action'},
            width: 100
        }
    ];

    created() {
        NotificationStore.updateNotificationParams({...this.params, targetType: NotificationTargetType.Employee})
        NotificationStore.listNotification(NotificationStore.params)
    }

    get notifications() {
        return NotificationStore.ids.map((id: number) => NotificationStore.data[id]);
    }

    get pagination() {
        return {
            current: NotificationStore.meta.page,
            pageSize: NotificationStore.meta.limit,
            total: NotificationStore.meta.total,
            showTotal: (total: number) => `Tổng cộng ${total} thông báo`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    sendNotification() {
        this.$router.push({name: "createNotificationEmployee"});
    }

    onChangePage(pagination: any) {
        NotificationStore.listNotification({
            ...NotificationStore.params,
            page: pagination.current,
            limit: pagination.pageSize
        });
    }

    @Watch("params", {deep: true})
    onChangeParams(val: any) {
        NotificationStore.updateNotificationParams({...NotificationStore.params, ...val});
        NotificationStore.listNotification(NotificationStore.params);
    }
}
